import {
  PLACE_ALL,
  PLACE_GET,
  PLACE_DEL,
  PLACE_PUT,
  PLACE_POST,
  PLACE_LOADING,
  PLACE_ERROR,
} from '../types';

import api from '../../../configs/api';

export const placeCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: PLACE_LOADING });
    const { data } = await api.post(`${process.env.REACT_APP_API_URL}/place`, {
      ...payload,
    });
    dispatch({ type: PLACE_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PLACE_ERROR });
    throw new Error(error);
  }
};

export const placeAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/place?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: PLACE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PLACE_ERROR });
    throw new Error(error);
  }
};

export const placeGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/place/${id}`,
    );
    if (status === 200) {
      dispatch({ type: PLACE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PLACE_ERROR });
    throw new Error(error);
  }
};

export const placeStateSet = (data) => async (dispatch) => {
  dispatch({ type: PLACE_ALL, payload: data });
};

export const placePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: PLACE_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/place/${id}`,
      payload,
    );
    dispatch({ type: PLACE_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PLACE_ERROR });
    throw new Error(error);
  }
};

export const placeDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: PLACE_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/place/${id}`,
    );
    dispatch({ type: PLACE_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PLACE_ERROR });
    throw new Error(error);
  }
};
